import { BookingAttendeeBookingService } from './booking-attendee-booking-service.model';
import { Price } from "./cart/price.model"

import * as moment from 'moment';
import 'moment-timezone';
moment.tz.setDefault("Europe/Ljubljana");

export class BookingAttendee {
  
  public id: string;
  public bookingAttendeeBookingServices: BookingAttendeeBookingService[];
  public start: string;
  public end: string;
  public durationInSeconds: number;
  public total: Price;

  public name: string;
  public surname: string;
  public phone: string;
  public email: string;

  public street: string;
  public zipCode: string;
  public city: string;
  public country: string;
  public countryCode: string;

  public dateOfBirth: string;
  public personalIdentNumber: string;
  public passportNumber: string;

  public notifications: boolean = false;

  constructor(
    obj?: any 
  ) {
    this.id = obj && obj.id || null;

    this.name = obj && obj.name || null;
    this.surname = obj && obj.surname || null;
    this.phone = obj && obj.phone || null;
    this.email = obj && obj.email || null;

    this.street = obj && obj.street || null;
    this.zipCode = obj && obj.zipCode || null;
    this.city = obj && obj.city || null;
    this.country = obj && obj.country || null;
    this.countryCode = obj && obj.countryCode || null;

    this.dateOfBirth = obj && obj.dateOfBirth || null;
    this.personalIdentNumber = obj && obj.personalIdentNumber || null;
    this.passportNumber = obj && obj.passportNumber || null;

    this.notifications = obj && obj.notifications || false;

    if ( obj && obj.bookingAttendeeBookingServices   ) {
       
       this.bookingAttendeeBookingServices = [];
       
       for (let babs of obj.bookingAttendeeBookingServices ) {

         if ( babs instanceof BookingAttendeeBookingService ) {
           this.bookingAttendeeBookingServices.push( babs );
         } else {
           this.bookingAttendeeBookingServices.push( new BookingAttendeeBookingService( babs ) );
         }

       }

       for (let a of this.bookingAttendeeBookingServices ) {

         if ( !this.start || moment(a.bookingService.start) < moment(this.start) ) {
           this.start = a.bookingService.start;
         }

         if ( !this.end || moment(a.bookingService.end) < moment(this.end) ) {
           this.end = a.bookingService.end;
         }

         let ms = moment(this.start);
         let me = moment(this.end);
         
         this.durationInSeconds = me.diff(ms, 'seconds');


         if ( !this.end || moment(a.bookingService.end) < moment(this.end) ) {
           this.end = a.bookingService.end;
         }

         let priceAmount = ( a.bookingService.price && a.bookingService.price.amount ) ?  a.bookingService.price.amount: 0.00;
         let priceCurrency = ( a.bookingService.price && a.bookingService.price.currency) ?  a.bookingService.price.currency: 'EUR';

         if (!this.total) {
           this.total = new Price( priceAmount, priceCurrency );
         } else {
           this.total.amount += priceAmount;
         }

       }


    }



  }

  composeNameSummaryLine() {

    let nameArr: string[] = [];

    if ( this.name ) {
      nameArr.push( this.name );
    }

    if ( this.surname ) {
      nameArr.push( this.surname );
    }

    let nameStr: string = '';
    nameStr += nameArr.join(' ');

    return nameStr.trim() || 'Brez imena';

  }

  composeContactSummaryLine() {

    let contactArr: string[] = [];

    if ( this.email ) {
      contactArr.push( this.email );
    }

    if ( this.phone ) {

      let phone = this.phone;

      if ( this.phone.substr(0,5) === '+386 ') {
        phone = '0' + this.phone.substr(5,2) + ' ' + this.phone.substr(7,3) + ' ' + this.phone.substr(10,3);
      }

      contactArr.push( phone );
    }

    if ( this.notifications ) {
      contactArr.push('🗨️')
    }

    let contactDataStr: string = '';
    contactDataStr += contactArr.join(' ');

    return contactDataStr.trim() || '';

  }

  composeAddressSummaryLine() {

    let addressArr: string[] = [];

    if ( this.street ) {

      let comma = '';
      if ( this.zipCode || this.city || this.country ) {
        comma += ',';
      }

      addressArr.push( this.street + comma );
    }

    if ( this.zipCode ) {

      addressArr.push( this.zipCode );

    }

    if ( this.city) {

      let comma = '';
      if ( this.country ) {
        comma += ',';
      }

      addressArr.push( this.city + comma );

    }

    if ( this.country) {
      addressArr.push( this.country );
    }

    let addressStr: string = '';
    addressStr += addressArr.join(' ');

    return addressStr.trim() || '';

  }



  
}